import {ConfirmationButton} from "./confirmation-button.model";

export class ConfirmationModel {
  public imagePath: string = "";
  public prompt: string = "";
  public hint: string = "";
  public buttons: ConfirmationButton[] = [];

  public constructor(init?:Partial<ConfirmationModel>) {
    Object.assign(this, init);
  }
}
